import { AfterViewInit, Component, Input } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { StudyFile } from 'src/app/models/Study/study-file.model';
import { MediaCategory } from 'src/app/models/media/media-category.model';
import { StudiesFacade } from 'src/app/shared-new/store/studies/studies.facade';
import { MatDataSource } from 'src/app/shared-new/util/mat-datasource';
import Swal from 'sweetalert2';
import { ImageModalComponent } from '../image-modal/image-modal.component';
import { MediaGroup } from '../../../../models/media/media-group.model';

@Component({
  selector: 'category-modal',
  templateUrl: './category-modal.component.html',
  styleUrls: ['./category-modal.component.scss'],
})
export class CategoryModalComponent implements AfterViewInit {
  @Input() public mediaCategoriesLeft: MediaCategory[] = [];
  @Input() public mediaCategoriesRight: MediaCategory[] = [];
  @Input() public mediaGroups: MediaGroup[] = [];
  @Input() public studyFile: StudyFile = null;
  @Input() public hideUploadAsAdditional: boolean = false;
  searchText: string = '';
  categoryName: string = '';
  selectedCategoryId: number = null;
  selectedGroupNames: string[] = [];
  selectedForeOrHinds: string[] = [];
  selectedAssignedOrUnAssigned: boolean[] = [];
  form: FormGroup = new FormGroup({
    reason: new FormControl('', [Validators.required]),
  });

  public dataSource: MatDataSource<MediaCategory>;
  public dataSource2: MatDataSource<MediaCategory>;

  public displayedColumns = [
    //'checkbox',
    'name',
    'assignedFileName',
    'mediaGroupName',
    'leftOrRight',
    'foreOrHind',
    'action',
  ];

  constructor(
    public modal: NgbActiveModal,
    private modalService: NgbModal,
    private studyFacade: StudiesFacade
  ) { }

  private MapButtonsRendering(mediaCategories: MediaCategory[]): MediaCategory[] {
    return mediaCategories.map((category) => {
      if (category.matchedStudyFileIds.length > 0 /*&& category.id == this.selectedCategoryId*/) {
        category.isShowReplace = true;
      }
      if (category.matchedStudyFileIds.length == 0 /*&& category.id !== this.selectedCategoryId*/) {
        category.isShowAssign = true;
      }
      return category;
    });
  }

  ngOnInit(): void {
    this.selectedCategoryId = this.studyFile.mediaCategoryId;
    this.mediaCategoriesLeft = this.MapButtonsRendering(this.mediaCategoriesLeft);
    this.mediaCategoriesRight = this.MapButtonsRendering(this.mediaCategoriesRight);
    this.categoryName = this.studyFile.categoryName;
    this.dataSource = new MatDataSource(
      this.mediaCategoriesLeft.sort((a, b) => {
        let valueA = a.sortOrder ?? 0;
        let valueB = b.sortOrder ?? 0;
        return valueA > valueB ? 1 : valueA < valueB ? -1 : 0;
      }),
      null,
      true
    );

    this.dataSource2 = new MatDataSource(
      this.mediaCategoriesRight.sort((a, b) => {
        let valueA = a.sortOrder ?? 0;
        let valueB = b.sortOrder ?? 0;
        return valueA > valueB ? 1 : valueA < valueB ? -1 : 0;
      }),
      null,
      true
    );

    this.setFilterPredicate();
  }
  Search(e: any) {
    this.applyFilter(e.srcElement.value, 'global', null);
  }
  

  private setFilterPredicate() {
    this.dataSource.filterPredicate = (data: any, filter: string) => {
      const filterObj = JSON.parse(filter || '{}');

      const globalSearch = filterObj.globalSearch?.trim().toLowerCase() || '';
      const nameFilters = filterObj.names || []; // Array of selected names
      const foreOrHindFilters = filterObj.foreOrHinds || []; // Array of selected F/H
      const matchedFilters = filterObj.matched || []; // Array of selected assigned/unassigned

      // Check button filters
      const matchesButtonFilters =
        (!nameFilters.length || nameFilters.includes(data.mediaGroupName.toLowerCase())) &&
        (!foreOrHindFilters.length || foreOrHindFilters.includes(data.foreOrHind)) &&
        (!matchedFilters.length || matchedFilters.includes(data.matched));

      // Check global text search (search in all columns)
      const matchesGlobalSearch =
        !globalSearch || JSON.stringify(data).toLowerCase().includes(globalSearch);

      return matchesButtonFilters && matchesGlobalSearch;
    };

    this.dataSource2.filterPredicate = this.dataSource.filterPredicate; // Apply to both tables
  }

  applyFilter(value: any, filterBy: 'media' | 'foreOrHind' | 'global' | 'assign', event?: Event) {
    const filterValues = JSON.parse(this.dataSource.filter || '{}');

    if (filterBy === 'global') {
      if (value) {
        filterValues.globalSearch = value.trim().toLowerCase();
      } else {
        delete filterValues.globalSearch;
      }
    }

    if (filterBy === 'media') {
      if (this.selectedGroupNames.includes(value)) {
        this.selectedGroupNames = this.selectedGroupNames.filter(item => item !== value);
      } else {
        this.selectedGroupNames.push(value);
      }
      filterValues.names = this.selectedGroupNames.length ? this.selectedGroupNames.map(name => name.toLowerCase()) : undefined;
    }

    if (filterBy === 'foreOrHind') {
      if (this.selectedForeOrHinds.includes(value)) {
        this.selectedForeOrHinds = this.selectedForeOrHinds.filter(item => item !== value);
      } else {
        this.selectedForeOrHinds.push(value);
      }
      filterValues.foreOrHinds = this.selectedForeOrHinds.length ? this.selectedForeOrHinds : undefined;
    }

    if (filterBy === 'assign') {
      if (this.selectedAssignedOrUnAssigned.includes(value)) {
        this.selectedAssignedOrUnAssigned = this.selectedAssignedOrUnAssigned.filter(item => item !== value);
      } else {
        this.selectedAssignedOrUnAssigned.push(value);
      }
      filterValues.matched = this.selectedAssignedOrUnAssigned.length ? this.selectedAssignedOrUnAssigned : undefined;
    }

    this.dataSource.filter = JSON.stringify(filterValues);
    this.dataSource2.filter = JSON.stringify(filterValues);

    if (event) {
      (event.target as HTMLElement).blur(); // Remove focus from the button
    }
  }




  ngAfterViewInit(): void {
    window.setTimeout(() => {
      let selectedCat = this.mediaCategoriesLeft?.find(a => a.id === this.selectedCategoryId);
      if (selectedCat) {
        document.getElementById(`tr_cat_${selectedCat.id}`)?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, 100);

    window.setTimeout(() => {
      let selectedCat = this.mediaCategoriesRight?.find(a => a.id === this.selectedCategoryId);
      if (selectedCat) {
        document.getElementById(`tr_cat_${selectedCat.id}`)?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, 100);
  }



onSubmit(): void {
  this.modal.close(this.form.value.reason);
}

  changeCategory(mediaCategoryId: number, replacing: boolean = false, extra: boolean = false): void {
    this.modal.close({ mediaCategoryId, replacing, extra });
}

dismiss(): void {
  this.modal.dismiss();
}

discardImage(): void {
  Swal.fire({
    title: 'Delete File',
    text: 'Do you want to delete this file?',
    showCancelButton: true,
    cancelButtonText: 'Cancel',
    cancelButtonColor: '#6c757d',
    confirmButtonText: 'Delete',
    confirmButtonColor: '#1b6da6',
  }).then((result) => {
    if (result.value) {
      this.studyFacade.deleteStudyFile(this.studyFile.studyFileId);
      this.modal.dismiss();
    }
  });
}

addToAdditional(): void {
  this.studyFacade.updateStudyFile(
    this.studyFile.studyFileId,
    this.studyFile.mediaCategoryId,
    false,
    true,
    true,
    
  );
  this.modal.dismiss();
}

getFileName(fileName: string): string {
  return fileName.split('.dcm')[0];
}
clearSearch() {

  this.searchText = '';
  this.applyFilter('', 'global', null);
}

viewImage(): void {
  const studyFile: StudyFile = this.studyFile;
  //this.activityStart.emit({ studyFile, activityId: Activity.XRayView })
  const modalRef = this.modalService.open(ImageModalComponent, {
    size: '75-width',
    centered: true,
    keyboard: false,
    backdrop: 'static',
  });
  modalRef.componentInstance.url = studyFile.thumbURL;
  modalRef.componentInstance.studyFile = studyFile;
  modalRef.result.then(
    (result) => {
      //this.activityEnd.emit(Activity.XRayView);
    },
    (reason) => {
      //this.activityEnd.emit(Activity.XRayView);
    }
  );
}
}
